// Core imports and dependencies
import Grid from "@mui/material/Grid2";
import SuggestionDropdown from "../common/suggestionDropdown";
import QueryButton from "../common/querybutton";
import "./suggestion.css";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { FailureToast, SuccessToast } from "../../utils/commonunctions";
import { Button, Tooltip } from "@mui/material";
import AddSuggestionModal from "./addSuggestionModal";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import CommentIcon from "@mui/icons-material/Comment";
import {
  createClassesApi,
  editClassesApi,
  getChoiceApi,
  getClassdataApi,
} from "../../redux/action/UserAction";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../redux/slices/userSlice";
import Loader from "../loader";
import InfoIcon from "@mui/icons-material/Info";
import AlertDialogSlide from "../sidebar/deleteModal";
import EditSuggestionModal from "../../pages/user/editSuggestion/editSuggestionModal";

// Component to render dynamic suggestion form fields and manage related modals
const SuggestionContent = ({
  onGenerateQuery,
  setSuggestionValue,
  ismodify,
  generateSentence,
  oldOptions,
  isModifyQuery,
  setOptions,
}) => {
  const dispatch = useDispatch();
  const { allClassData, classDataLoading, modalClassesLoading, getChoices } =
    useSelector(userSelector);

  // Local state management
  const [shouldFetch, setShouldFetch] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModal, setIsEditModel] = useState(false);
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [saveCatagoryID, setSaveCatagoryID] = useState("");

  const initialForm = {
    name: "",
    icon: "",
    is_deleted: true,
    is_option: false,
  };
  const [formData, setFormData] = useState(initialForm);

  // Modal handlers for Add/Edit/Delete actions
  const handleOpen = (id) => {
    console.log("id for delete", id);
    setOpen(true);
    setDeleteId(id);
  };

  const handleAddClick = (action, formData) => {
    setIsModalOpen(true);
    setIsEditModel(false);
    if (action === "edit") {
      setIsEditModel(true);
      setFormData(formData);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setFormData(initialForm);
  };

  // API actions to save or edit class
  const handleSaveData = (newData) => {
    dispatch(
      createClassesApi(
        newData,
        setShouldFetch,
        setIsModalOpen,
        setFormData,
        initialForm
      )
    );
  };

  const handleEditClass = (newData) => {
    const body = {
      is_option: newData.is_option,
      name: newData.name,
    };
    dispatch(
      editClassesApi(
        setShouldFetch,
        setIsModalOpen,
        setFormData,
        initialForm,
        newData,
        body
      )
    );
  };

  // Prepare options for edit modal
  const handleEdit = (id, categoryId) => {
    const findoptionLabel = () => {
      return getChoices?.reduce((acc, item) => {
        if (item?.choice_type.toLowerCase() === id?.toLowerCase()) {
          return [
            ...acc,
            { label: item.value, value: item.value, id: item.id },
          ];
        }
        return acc;
      }, []);
    };
    const finaldata = findoptionLabel();
    const data = {
      finaldat: finaldata,
      id: id,
      categoryId: categoryId,
      isEdit: true,
    };
    setSaveCatagoryID(data);
    setEditModal(!editModal);
  };

  // Formik for managing input state and validations
  const formik = useFormik({
    initialValues: {
      subject: "",
    },
    validateOnChange: true,
    onSubmit: (values) => {
      const suggestionvalue = Object.keys(values).reduce((acc, key) => {
        if (values[key] && values[key].trim() !== "") {
          const modifiedKey = key === "output" ? "Output" : key;
          acc[modifiedKey] = values[key];
        }
        return acc;
      }, {});
      setSuggestionValue(suggestionvalue);
      onGenerateQuery(values);
    },
  });

  // Initial API calls
  useEffect(() => {
    dispatch(getChoiceApi());
  }, []);

  // Reflect formik state into parent component
  useEffect(() => {
    setOptions(formik.values);
  }, [formik.values]);

  // Validate subject field before triggering generation(save)
  const handleValidation = () => {
    if (!formik?.values?.subject?.trim()) {
      FailureToast("Subject is a required field");
    } else {
      generateSentence(formik?.values);
    }
  };
  const handleCopy = () => {
      if (!formik?.values?.subject?.trim()) {
        FailureToast("Subject is a required field");
        return;
      }
  
      navigator.clipboard
        .writeText(formik?.values?.subject)
        .then(() => {
          SuccessToast("Subject has been saved");
        })
        .catch((err) => {});
    };

  // Fetch class data once when component mounts or after a modification
  useEffect(() => {
    if (shouldFetch) {
      dispatch(getClassdataApi());
      setShouldFetch(false);
    }
  }, [shouldFetch]);

  // Handle dropdown selection
  const choiceOption = (e) => {
    const selectedValue = e?.target?.value;
    const selectName = e?.target?.name;
    formik.setFieldValue(selectName, selectedValue);
  };

  // If in modify mode, populate formik with old values
  useEffect(() => {
    if (oldOptions) {
      const formattedOptions = { ...oldOptions };
      formik.resetForm({ values: formattedOptions });
    }
  }, [oldOptions, isModifyQuery]);

  return (
    <>
      {/* Delete confirmation modal */}
      {open && (
        <AlertDialogSlide
          open={open}
          setOpen={setOpen}
          setShouldFetch={setShouldFetch}
          deleteId={deleteId}
          shouldFetch={shouldFetch}
        />
      )}

      {/* Class loader or form */}
      {modalClassesLoading ? (
        <Loader />
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <Button
            className="add-btn"
            variant="contained"
            onClick={() => handleAddClick("create", null)}
          >
            + Add Classes
          </Button>

          {/* Class input layout */}
          <Grid
            className="container"
            container
            alignItems="stretch"
            spacing={2}
          >
            {classDataLoading ? (
              <Loader />
            ) : (
              allClassData?.map((data) => (
                <>
                  {/* Class label and actions */}
                  <Grid size={{ lg: 3, md: 3, xs: 4 }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "8px",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          gap: "8px",
                          width: "80%",
                        }}
                      >
                        {/* Only name + info icon inside gray background */}
                        <div
                          className="suggestionContainer"
                          style={{ flex: 1 }}
                        >
                          <p style={{ margin: 0 }}>{data?.name}</p>
                          <Tooltip title={data?.name}>
                            <InfoIcon
                              sx={{ fontSize: "18px", color: "grey" }}
                            />
                          </Tooltip>
                        </div>
                      </div>
                      {/* Edit/Delete icons outside gray background */}
                      {data?.is_deleted && (
                        <div
                          style={{
                            display: "flex",
                            gap: "5px",
                            alignItems: "center",
                            justifyContent: "start",
                          }}
                        >
                          <ModeEditOutlineIcon
                            sx={{
                              fontSize: "18px",
                              color: "#4b5669",
                              cursor: "pointer",
                            }}
                            onClick={() => handleAddClick("edit", data)}
                          />
                          <DeleteOutlineIcon
                            sx={{
                              fontSize: "18px",
                              color: "#4b5669",
                              cursor: "pointer",
                            }}
                            onClick={() => handleOpen(data?.id)}
                          />
                        </div>
                      )}
                    </div>
                  </Grid>

                  {/* If field has options, show dropdown */}
                  <Grid size={{ lg: 3, md: 2, xs: 4 }}>
                    {data?.is_option && (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <SuggestionDropdown
                          id={data?.name}
                          formikvalues={formik.values}
                          options={getChoices}
                          onChange={(e) => choiceOption(e)}
                          ismodify={ismodify}
                        />
                        <EditNoteIcon
                          onClick={() => handleEdit(data?.name, data.id)}
                          style={{ color: "#F29D38", cursor: "pointer" }}
                        />
                      </div>
                    )}
                  </Grid>

                  {/* Input field for each class */}
                  <Grid size={{ lg: 6, md: 6, xs: 4 }}>
                    <input
                      value={formik.values[data?.name]}
                      onChange={formik.handleChange}
                      name={data?.name}
                      placeholder={data?.is_option ? "choose" : "Fill in"}
                      type="text"
                      className="suggestioninput"
                    />
                  </Grid>
                </>
              ))
            )}

            {/* Form buttons */}
            <div className="suggestioncontentbtn">
              <QueryButton
                type={"submit"}
                btntext={"Generate Query"}
                btnclick={handleValidation}
              />
              <QueryButton
                type={"button"}
                btntext={"Save Query"}
                btnclick={handleCopy}
              />
            </div>
          </Grid>
        </form>
      )}

      {/* Add/Edit modal */}
      <AddSuggestionModal
        formData={formData}
        setFormData={setFormData}
        open={isModalOpen}
        onClose={handleCloseModal}
        onSave={handleSaveData}
        onEdit={handleEditClass}
        isEditModel={isEditModal}
      />

      {/* Modal for editing dropdown option values */}
      <EditSuggestionModal
        setEditModal={setEditModal}
        editModal={editModal}
        saveCatagoryID={saveCatagoryID}
      />
    </>
  );
};

export default SuggestionContent;
